import Youtube from '../youtube/index';

import channelTypes from '../../constants/channel-types';
import urlTypes from '../youtube/url-types';


const youtubeAdapter = new Youtube();


export const lists = {
  [`${channelTypes.YOUTUBE_FEED}.${urlTypes.PLAYLIST}`]: youtubeAdapter.playlists.get,
  [`${channelTypes.YOUTUBE_FEED}.${urlTypes.CHANNEL}`]: youtubeAdapter.channels.get,
};


export const listItems = {
  [`${channelTypes.YOUTUBE_FEED}.${urlTypes.PLAYLIST}`]: youtubeAdapter.videos.getByPlaylistId,
  [`${channelTypes.YOUTUBE_FEED}.${urlTypes.CHANNEL}`]: youtubeAdapter.videos.getByChannelId,
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/external-requests.js